import FamlaServices from './FamlaServices';

export type ProcessCreationType = 'AI' | 'HUMAN' | 'IMAGE' | 'MANUAL';
export type DiagramOutputType = 'STANDARD' | 'BPMN';

export interface ProcessIndustry {
    _id: string;
    name: string;
    description?: string;
}

export interface CreateProcessInput {
    title: string;
    description: string;
    industryId: string;
    language: string;
    type: ProcessCreationType;
    diagramOutput?: DiagramOutputType;
}

export const sortProcessIndustries = (industries: ProcessIndustry[]): ProcessIndustry[] =>
    [...industries].sort((a, b) => {
        const aOther = ['autre', 'other'].includes(a.name.toLowerCase());
        const bOther = ['autre', 'other'].includes(b.name.toLowerCase());
        if (aOther !== bOther) return aOther ? 1 : -1;
        return a.name.localeCompare(b.name);
    });

/** Secteur par défaut pour un canvas vierge (Autre/Other, sinon le premier disponible). */
export const pickDefaultIndustryId = (industries: ProcessIndustry[]): string | null => {
    if (!industries.length) return null;
    const sorted = sortProcessIndustries(industries);
    const fallback =
        sorted.find((item) => ['autre', 'other'].includes(item.name.toLowerCase())) ?? sorted[0];
    return fallback._id;
};

export const loadProcessIndustries = async (
    accessToken: string,
    language: string,
): Promise<ProcessIndustry[]> => {
    const response = await FamlaServices(
        'api_host',
        `/industry/?lang=${language}`,
        'GET',
        '',
        accessToken,
    );
    if (response.status !== 200 || !Array.isArray(response.body?.data)) {
        throw new Error('Unable to load process industries');
    }
    return response.body.data;
};

export const createProcess = async (
    input: CreateProcessInput,
    accessToken: string,
) => {
    const payload = {
        project_id: '',
        title: input.title,
        description: input.description,
        is_sub_process: false,
        process_id: '',
        created_at: Date.now(),
        type: input.type,
        diagram_output: input.diagramOutput ?? 'STANDARD',
    };

    return FamlaServices(
        'api_host',
        `/process/${input.industryId}?language=${input.language}`,
        'POST',
        payload,
        accessToken,
    );
};
